import WebRepository from '../web/WebRepository'
import Api from 'clients/web/Api'
import PatientSpo2 from 'model/PatientSpo2'
import moment from 'moment'

export class PatientSpo2Repository extends WebRepository<PatientSpo2> {
  constructor() {
    super(new Api('spo2'))
  }

  async getLastValue(userId: any): Promise<any> {
    return super.search({
      limit: 1,
      sort: {
        start_timestamp: -1,
      },
      selector: {
        patientId: userId,
      },
    })
  }

  async searchByDate(
    userId: any,
    startDate: moment.Moment | undefined,
    endDate: moment.Moment | undefined,
  ): Promise<PatientSpo2[]> {
    let startTimeInSeconds = startDate!.valueOf() / 1000
    let endTime = endDate!.valueOf() / 1000
    let boundaries = []

    var isDayPeriod = moment(startDate).isSame(moment(endDate), 'day')

    for (var i = startTimeInSeconds; i <= endTime + 1; i += isDayPeriod ? 60 : 24 * 60 * 60)
      boundaries.push(i)

    return super.aggregateAll(
      {
        selector: [
          {
            $match: {
              patientId: userId,
              start_timestamp: {
                $gt: startDate?.unix(),
                $lt: endDate?.unix(),
              },
            },
          },
          {
            $bucket: {
              groupBy: '$start_timestamp',
              boundaries: boundaries,
              output: {
                sum: {
                  $sum: '$avg',
                },
                count: {
                  $sum: 1,
                },
                // Distinct oxygen statuses in this bucket — see the note in
                // PatientBloodPressureRepository on why this is a set and why the null matters.
                oxygenStatuses: {
                  $addToSet: { $ifNull: ['$context.oxygenStatus', null] },
                },
                // The apparatus, present only on supplemental-oxygen readings. Preferred over
                // the status when showing the reading, since it says strictly more.
                oxygenDeliveries: {
                  $addToSet: { $ifNull: ['$context.oxygenDelivery', null] },
                },
              },
            },
          },
          {
            $addFields: {
              avg: {
                $divide: ['$sum', '$count'],
              },
              start_timestamp: '$_id',
            },
          },
          {
            $project: {
              sum: 0,
              count: 0,
              _id: 0,
            },
          },
        ],
      },
      (doc: any) => {
        return {
          start_timestamp: doc.start_timestamp,
          isDayPeriod: isDayPeriod,
          avg: doc.avg,
          oxygenStatuses: doc.oxygenStatuses,
          oxygenDeliveries: doc.oxygenDeliveries,
        }
      },
    )
  }
}

export default new PatientSpo2Repository()
